import { baseQuery } from '../baseQuery';

type PostInvoiceParams = {
  serviceId: string;
};

export const postEmailServiceInvoice = async ({ serviceId }: PostInvoiceParams) => {
  const { data } = await baseQuery('email-service-invoice', {
    type: 'POST',
    body: {
      job_id: parseInt(serviceId),
    },
  });

  return data as never[];
};
